import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearErrorsForget } from "../../redux/slices/authAdminSlice";
import { forgotPassword } from "../../redux/actions/authActions";
import { RootState, AppDispatch } from "../../redux/store";
import LoginLogo from "../../assets/LoginLogo.png";
import { Spin, notification } from "antd";
import { useTranslation } from "react-i18next";

const customIcon = (
  <div className="w-[32px] h-[32px] border-[4px] border-solid border-t-[#212529] border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>
);

const ForgetPassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { error, emailError } = useSelector((state: RootState) => state.auth);
  const {t} = useTranslation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    dispatch(clearErrorsForget());

    const result = await dispatch(forgotPassword({ email }));

    if (forgotPassword.fulfilled.match(result)) {
      notification.success({
        message: "Success",
        description: "Password reset link has been sent to your email.",
      });
    } else {
      notification.error({
        message: "Error",
        description: error || "There was an error processing your request.",
      });
    }

    setIsSubmitting(false);
  };

  return (
    <div className="relative">
      <div className="flex flex-col items-center justify-center h-screen gap-6 bg-bg-login/register">
        <img src={LoginLogo} alt="Logo" />
        <form onSubmit={handleSubmit} className="flex flex-col gap-2 items-center">
          <label className="text-sm self-start">{t ("forgotpassword.email")}</label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            className="w-[312px] h-[52px] rounded-xl pl-4 text-sm"
          />
          {emailError && <p className="text-sm text-red-500">{emailError}</p>}

          <button
            type="submit"
            className="w-[312px] h-[52px] bg-loginButton rounded-xl text-white mt-4"
            disabled={isSubmitting}
          >
            {t ("forgotpassword.sendemail")}
          </button>

          {/* Spinner appears below button when submitting */}
          {isSubmitting && <div className="mt-4"><Spin indicator={customIcon} /></div>}

          {error && <p className="text-sm text-red-500 mt-2">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default ForgetPassword;
